import { Container } from '../../components/container/container';
import { Page } from '../../components/page-layout/page';
import { createFileRoute } from '../../utils/route-factory';

function RouteComponent() {
  return (
    <Page
      title='Manual Templates Settings'
      breadcrumbs={[
        {
          label: 'History',
        },
        {
          label: 'Manual Templates Settings',
        },
      ]}
    >
      <Container>TODO</Container>
    </Page>
  );
}

export const Route = createFileRoute({
  path: '/settings/manual-templates',
  component: RouteComponent,
  type: 'auth',
  locationRequired: true,
});
